import React, { FC } from 'react'
import { Text } from 'react-native-paper'
import { TextStyle } from 'react-native'
import { useBaseTextStyle } from '../../ions/styles'
import { helpers } from '@linqpal/common-frontend'

const { composeStyle } = helpers

type TextProps = {
  style?: TextStyle
  center?: boolean
  stretch?: boolean
  children?: React.ReactNode
  testID?: string
}
export const TextHeading: FC<TextProps> = ({
  style,
  center,
  stretch,
  children,
  testID = '',
  ...props
}): JSX.Element => {
  const { heading } = useBaseTextStyle()

  return (
    <Text
      {...props}
      style={composeStyle(
        heading,
        style,
        center && { textAlign: 'center' },
        stretch && { width: '100%' },
      )}
      testID={testID}
    >
      {children}
    </Text>
  )
}
